module.exports = __webpack_public_path__ + "static/media/Logo.489a4840.png";